export var getCampaignQuotaStatsEndpoint = function(builder) {
    return builder.query({
        query: function(param) {
            var campaignId = param.campaignId;
            return "/campaigns/".concat(campaignId, "/campaign_quota_stats");
        }
    });
};
